module.exports = __webpack_public_path__ + "static/media/module.3daa32be.svg";